import styled from '@emotion/styled';
import { Alert, Divider, Loader, PageHeader, tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { useCurrentUser } from '@hotjar/user';
import { useWindowTitle } from '@hotjar/webapp/hooks/useWindowTitle';
import { FoundingMemberBadge } from '../FoundingMemberBadge';
import { Logo } from '../Logo';
import { TransferOwnershipSection } from '../TransferOwnershipSection';

export const Page = styled.article`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x4};
`;

export function AccountPage(): JSX.Element {
  const { t } = useTranslation('common');

  useWindowTitle(t('settings-account.page-title'));

  const { data, isLoading } = useCurrentUser();

  return (
    <Page>
      <PageHeader title={t('settings-account.page-title')} />

      {isLoading && <Loader size="l" />}

      {!isLoading && (
        <>
          {!data?.isAccountAdmin && (
            <Alert kind="warning">{t('settings-account.page-permission-warning')}</Alert>
          )}

          {data?.isAccountAdmin && (
            <>
              <TransferOwnershipSection />
              <Divider spacing="l" />
              <Logo />
            </>
          )}

          {data?.isFoundingMember && (
            <>
              <Divider spacing="l" />
              <FoundingMemberBadge />
            </>
          )}
        </>
      )}
    </Page>
  );
}
